/** Format decimal API strings without losing precision through Number. */
export const formatAmount = (amount: string | number): string => {
  const value = String(amount).trim()
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) {
    return Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }
  const negative = value.startsWith('-')
  const [whole, fraction = ''] = value.replace(/^[+-]/, '').split('.')
  let cents =
    BigInt(whole || '0') * 100n + BigInt(fraction.padEnd(2, '0').slice(0, 2))
  if (Number(fraction[2] ?? 0) >= 5) cents += 1n
  const digits = cents.toString().padStart(3, '0')
  return `${negative && cents !== 0n ? '-' : ''}${digits.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${digits.slice(-2)}`
}

export const formatDisplayExchangeRate = (
  currency: string,
  exchangeRate?: string,
) => {
  if (currency === 'USD') return '1.0000'
  if (!exchangeRate) return '-'

  const rate = Number(exchangeRate)
  if (!Number.isFinite(rate) || rate === 0) return '-'

  return (1 / rate).toFixed(4)
}
